export const enableSuccessToastInfo = (flag) =>{
    return{
        type:'SET_SUCCESS_TOAST',
        value:flag
    }
};

export const enableTokenizerErrorToastInfo = (flag) =>{
    return{
        type:'SET_TOKENIZER_ERROR_TOAST',
        value:flag
    }
};

export  const showApiErrorMessage = (flag) => {
    return{
        type:'SET_API_ERROR_TOAST',
        value: flag
    }
}
export  const showMemoApiErrorMessage = (flag) => {
    return{
        type:'SET_MEMO_API_ERROR_TOAST',
        value: flag
    }
}

export  const showScriptErrorMessage = (flag) => {
    return{
        type:'SET_SCRIPT_ERROR_TOAST',
        value: flag
    }
}

export const showCyberSourceErrorMessage = (flag) => {
    return{
        type:'SET_CYBER_SOURCE_ERROR_TOAST',
        value: flag
    }
}

export const showNoWalletEventErrorMessage = (flag) => {
    return{
        type:'SET_NO_WALLET_EVENT_ERROR_TOAST',
        value: flag
    }
}
export const showGenericErrorToast = (flag) => {
    return{
        type:'SET_GENERIC_ERROR_TOAST',
        value: flag
    }
}
export const showTnCErrorToast = (flag) => {
    return{
        type:'SET_TNC_ERROR_TOAST',
        value: flag
    }
}
